module.exports = __webpack_public_path__ + "img/logo-small-light.0c603515.svg";